export default __webpack_public_path__ + "static/media/road-icon.51f3f415.png";